import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  bubble: {
    background: theme.palette.secondary.main,
    position: "fixed",
    bottom: 20,
    right: 20,
    zIndex: 999,
    borderRadius: "22px",
    gap: theme.spacing(2),
    boxShadow: "0px 1px 5px 0px #0000001F",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
    transition:
      "width 0.5s ease-in-out, height 0.5s ease-in-out, opacity 0.5s ease",
  },
  bubbleOpen: {
    width: "374px",
    height: "548px",
  },
  bubbleClosed: {
    cursor: "pointer",
    width: "212px",
    height: "49px",
  },
  emailIcon: {
    color: theme.palette.primary.main,
    marginRight: "8px",
  },
  emailIconHidden: {
    display: "none",
  },
  btnTitle: {
    color: theme.palette.primary.main,
    fontWeight: 500,
    fontSize: "14px",
  },
  header: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    height: "49px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    background: theme.palette.secondary.main,
    zIndex: 100,
    padding: theme.spacing(2),
  },
  chatBase: {
    position: "fixed",
    bottom: "120px",
    right: 20,
    transition: "width 0.3s ease, height 0.3s ease, opacity 0.3s ease",
    overflow: "hidden",
    zIndex: 1000,
    boxShadow: "0px 1px 5px 0px #0000001F",
    borderRadius: "0px 0px 22px 22px",
  },
  openChat: {
    width: "100%",
    height: "370px",
    background: "white",
    borderRadius: "22px",
  },
  chatContent: {
    paddingTop: "60px",
    position: "relative",
    borderRadius: "22px",
    background: theme.palette.otherElementsBackground.main,
    height: "100%",
    transition: "opacity 0.5s ease-in-out",
    opacity: 1,
    overflow: "hidden",
  },
  chatContentHidden: {
    opacity: 0,
    height: 0,
    width: 0,
  },
  closedChat: {
    width: 0,
    height: 0,
    opacity: 0,
  },
  badge: {
    float: "right",
    background: theme.palette.error.main,
    color: "white",
    width: "min-content",
    minWidth: theme.spacing(3),
    height: theme.spacing(3),
    padding: 0,
    fontFamily: "Poppins",
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "150%",
  },
}));
